import { cva } from '@/styled-system/css';

export const listRootRecipe = cva({
  base: {
    textStyle: 'body',
    color: 'text.neutral',
    paddingInlineStart: 'looser',
  },
  variants: {
    appearance: {
      bullet: {
        listStyleType: 'disc',
      },
      number: {
        listStyleType: 'decimal',
      },
      none: {
        'listStyleType': 'none',
        'paddingInlineStart': 'none',
        '& ul': {
          paddingInlineStart: 'looser',
        },
      },
    },
  },
});
